module.exports = require("mitter-web-core");